/**
 * Validates a single field in the Contact Preferences form.
 * @param {string} name - Field name
 * @param {string} value - Field value
 * @returns {string|null} - Error message or null if valid
 */
export const validateContactPreferenceField = (name, value) => {
  if (["contactMethod", "refillContactMethod"].includes(name)) {
    if (!value || (typeof value === "string" && !value.trim())) {
      return "Please select a contact method";
    }
  }

  if (name === "quantity") {
    if (
      value === undefined ||
      value === null ||
      (typeof value === "string" && !value.trim())
    ) {
      return "Quantity is required";
    }
  }

  if (name === "daysSupply") {
    if (
      value === undefined ||
      value === null ||
      (typeof value === "string" && !value.trim())
    ) {
      return "Days supply is required";
    }
    if (Number.isNaN(Number(value)) || Number.parseInt(value) <= 0) {
      return "Please enter a valid number of days";
    }
  }
  
  return null;
};

/**
 * Validates the entire Contact Preferences form data.
 * @param {object} data - Contact preferences data
 * @returns {object} - Object containing errors for each field
 */
export const validateContactPreferencesForm = (data) => {
  const errors = {};
  const fields = ["contactMethod", "refillContactMethod", "quantity", "daysSupply"];
  
  fields.forEach(field => {
    const error = validateContactPreferenceField(field, data[field] || "");
    if (error) errors[field] = error;
  });
  
  return errors;
};
